import { useState } from "react";
import { useDeviceDetail, useSearchMeters } from "../../hooks";
import { useBaseComponent } from "@shared/base/hooks/useBaseComponent";
import {
  BookDown,
  Edit2,
  EyeIcon,
  FileBarChart2Icon,
  History,
} from "lucide-react";
import { CustomTable } from "@shared/components/CustomTable";
import { Input } from "@shared/ui/input";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { MeterDeviceSearch } from "../../types";
interface MeterOption {
  id: string;
  meter_number: string;
  [key: string]: any;
}

export const MeterSearch: React.FC = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [selectedMeter, setSelectedMeter] = useState(null);
  const remoteUtilityId  = useRemoteUtilityId();

  const headers = [
    { Label: "Device ID", FieldName: "deviceNo" },
    { Label: "Device Type", FieldName: "meterTypeDisplay" },
    { Label: "Meter Number", FieldName: "meterNumber" },
    { Label: "Installation Date", FieldName: "installedOn" },
    { Label: "Location", FieldName: "premiseName" },
    { Label: "Status", FieldName: "status", type: "status" },
    {
      Label: "Actions",
      FieldName: "",
      icons: [
        {
          key: "eye",
          title: "View device details",
          icon: <EyeIcon className="w-5 h-5" />,
        },
        {
          key: "edit",
          title: "Edit device configuration",
          icon: <Edit2 className="w-5 h-5" />,
        },
        {
          key: "history",
          title: "View device history logs",
          icon: <History className="w-5 h-5" />,
        },
        {
          key: "file-text",
          title: "Generate a device report",
          icon: <FileBarChart2Icon className="w-5 h-5" />,
        },
      ],
    },
  ];
  //radio button
  const [searchType, setSearchType] = useState<
    "device_number" | "meter_number"
  >("device_number");

  const radioDisplayName = searchType === "meter_number" ? "Meter" : "Device";
  const placeholder = `Enter ${radioDisplayName} Number`;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setQuery(value);

    if (value.trim() === "") {
      setFiltered([]);
      return;
    }
  }
  const handleSelect = (meter: MeterDeviceSearch) => {
    setSelectedMeter(meter.id);
    setQuery(meter.meterNumber + " - " + meter.deviceNo);
  };


  //   //hook for searching the meter or device for list
  const { data } = useSearchMeters({
    searchField: searchType,
    searchData: query,
    remoteUtilityId,
  });
const [filtered, setFiltered] = useState(data);

//hook for fetching the list from the selected device/meter
  const { data: list } = useDeviceDetail({
    meterId: selectedMeter,
    remoteUtilityId,
  });
  const meterList = list ? (Array.isArray(list) ? list : [list]) : [];
  const handleAction = (key: string, data: any) => {
    switch (key) {
      case "eye":
        navigate(`/mx/device-management/meter/view/${data.id}`);
        break;
    case 'edit':
      navigate(`/mx/device-management/meter/edit/${data.id}`);
      break;
    default:
      break;
    }
  }
  return (
    <div className="flex flex-col gap-4 border rounded-xl p-4 my-4">
      <p className="text-xl font-semibold">Meter Search</p>
     <div className="flex items-center gap-4 mb-4">
        {["device_number", "meter_number"].map((type) => (
          <label key={type} className="cursor-pointer select-none">
            <input
              type="radio"
              name="searchType"
              value={type}
              checked={searchType === type}
              onChange={() =>
                setSearchType(type as "device_number" | "meter_number")
              }
              className="mr-2"
            />
            {type === "device_number" ? "Device" : "Meter"}
          </label>
        ))}
      </div>
      <Input
        type="text"
        placeholder={placeholder}
        value={query}
        onChange={handleInputChange}
        className="w-full"
      />

      {data?.length > 0 && (
        <ul className="w-full shadow border rounded p-2 mt-2">
          {data?.map((meter) => (
            <li
              key={meter?.id}
              className="hover:bg-gray-200 p-2 text-sm rounded"
              onClick={() => handleSelect(meter)}
            >
              {meter.meterNumber + " - " + meter.deviceNo}
            </li>
          ))}
        </ul>
      )}
      {selectedMeter && meterList?.length && (
        <div>
          <div className="flex justify-between w-full my-4">
            <p className="text-xl font-semibold">Search Results</p>
            <p>{meterList?.length} results found</p>
          </div>
          <CustomTable data={meterList} headers={headers} showPagination={false} onIconClick={(key, data) => {handleAction(key, data);}} />
        </div>
      )}
    </div>
  );
};
